import React from 'react'
import WysiwygEditor from '../wysiwyg_editor/wysiwyg_editor.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'

export default ({ text = '', onChange, onBlur, onDelete }) => {
  return (
    <div className='termsandconditon'>
      <div className='editorcontent'>
        <WysiwygEditor
          className='termseditor'
          value={text}
          placeholder='setting.pdfTemplate.titleTermsandConditon'
          onChange={onChange}
          onBlur={onBlur}
        />
      </div>
      <div className='actioncontent'>
        <IconButton
          icon='common-item-delete'
          title='estimate.view.removeTermsandCondition'
          canHover={false}
          size='small'
          className='estimateview'
          onClick={onDelete}
        />
      </div>
    </div>
  )
}
